import * as HubspotForms from "../lib/hubspot-forms";
import * as InviewVideo from "../lib/inview-video";

import { Lightbox, ScrollEffects, ScrollListener, Appear, Drawer } from "pickles";

import Loading from "../lib/loading";
import Words from "../lib/words";

export default {
  init() {
    window.$ = window.$ || jQuery;

    // JavaScript to be fired on all pages

    Loading.init();
    Words.init();
    HubspotForms.init();
    InviewVideo.init();
    new Lightbox();
    new ScrollEffects();
    new Appear();
    new Drawer();

    // check if scrolled

    new ScrollListener(() => {
      $("body").toggleClass("scrolled", $(window).scrollTop() > 20);
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
